import type { CatalogOption } from '../options.ts';
import type { OptionAxis } from '../product-variants.ts';

export const chosenValuesOf = (axes: readonly OptionAxis[], optionId: string): readonly string[] =>
  axes.find((axis) => axis.optionId === optionId)?.valueIds ?? [];

const inCatalogOrder = (option: CatalogOption, valueIds: readonly string[]): string[] => {
  const chosen = new Set(valueIds);
  const known = option.values.map((value) => value.id).filter((id) => chosen.has(id));
  return [...known, ...valueIds.filter((id) => !known.includes(id))];
};

export const withValueToggled = (
  options: readonly CatalogOption[],
  axes: readonly OptionAxis[],
  option: CatalogOption,
  valueId: string,
): OptionAxis[] => {
  const current = chosenValuesOf(axes, option.id);
  const next = current.includes(valueId) ? current.filter((id) => id !== valueId) : [...current, valueId];
  const others = axes.filter((axis) => axis.optionId !== option.id);
  const changed = next.length === 0 ? [] : [{ optionId: option.id, valueIds: inCatalogOrder(option, next) }];
  const position = (axis: OptionAxis) =>
    options.find((entry) => entry.id === axis.optionId)?.position ?? Number.MAX_SAFE_INTEGER;
  return [...others, ...changed].toSorted((left, right) => position(left) - position(right));
};

export const withOriginToggled = (
  axes: readonly OptionAxis[],
  originOptionId: string,
  valueId: string,
): OptionAxis[] => {
  const current = chosenValuesOf(axes, originOptionId);
  const next = current.includes(valueId) ? current.filter((id) => id !== valueId) : [...current, valueId];
  const others = axes.filter((axis) => axis.optionId !== originOptionId);
  return next.length === 0 ? others : [...others, { optionId: originOptionId, valueIds: next }];
};
